import { render, staticRenderFns } from "./JudgesMain.vue?vue&type=template&id=d928f788&scoped=true&"
import script from "./JudgesMain.vue?vue&type=script&lang=js&"
export * from "./JudgesMain.vue?vue&type=script&lang=js&"
import style0 from "./JudgesMain.vue?vue&type=style&index=0&id=d928f788&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d928f788",
  null
  
)

export default component.exports